// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__29XLC","list":"BalanceDue_list__PlrKX","listRow":"BalanceDue_listRow__QF1J6","total":"BalanceDue_total__1p4L7"};